<template>
	<div class="order-search-body">
		<div class="filters-box-row">
			<div class="filters-container">
				<div class="input-box">
					<span>编号：</span>
					<el-input
						class="search-input"
						v-model="searchCode"
						placeholder="请输入商品/规格编号"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>名称：</span>
					<el-input
						class="search-input"
						v-model="searchName"
						placeholder="请输入商品名称/规格名称"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<!-- <div class="filters-container">
				<div class="input-box">
					<span>当前库存：</span>
					<el-input
						class="inventory-input"
						v-model="minInventory"
						placeholder="请输入库存"
						size="small"
						@input="orderInput"
						@keyup.enter.native="search">
					</el-input>
					<span style="margin: 0 5px">-</span>
					<el-input
						class="inventory-input"
						v-model="maxInventory"
						placeholder="请输入库存"
						size="small"
						@input="orderInput2"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div> -->
			<div class="filters-container" style="position:relative">
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
			</div>
		</div>
		<!-- <div class="filters-box-row filters-box-row2">
			<div class="filters-container" v-show="!collapse">
				<div class="input-box">
					<span>日期：</span>
					<div class="time-box">
						<div :class="searchDateType === 1 ? 'selected' : ''" @click="changeTime(1)">本年</div>
						<div :class="searchDateType === 2 ? 'selected' : ''" @click="changeTime(2)">本月</div>
						<div :class="searchDateType === 3 ? 'selected' : ''" @click="changeTime(3)">本周</div>
						<div :class="searchDateType === 4 ? 'selected' : ''" @click="changeTime(4)">今日</div>
						<div class="time-diy" :class="searchDateType === 5 ? 'selected' : ''">{{timeDiy}}<i class="el-icon-caret-bottom"></i>
							<el-date-picker
								@change="searchTime"
								v-model="dateValue"
								:clearable="false"
								:unlink-panels='true'
								class="time-input"
								size="small"
								type="datetimerange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								format='yyyy-MM-dd'
								value-format='yyyy-MM-dd'>
							</el-date-picker>
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<div class="filters-box-row filters-box-row3">
			<el-button size="small" type="primary" plain class="btn fx-btn export-btn" @click="exportExcel">
				<div></div>
				导出
			</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'search',
	props: {
		ids: {
			type: Array,
			default: () => []
		},
		AuthorityList: {
			type: Object
		}
	},
	data () {
		return {
			dateValue: [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrentMonthLast()],
			timeDiy: '自定义',
			collapse: false,
			searchCode: '',
			searchName: '',
			minInventory: '',
			maxInventory: '',
			searchDateType: 0,
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	created () {
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		if (window.sessionStorage.getItem('inventoryCheckSelect') && !this.filterFlag) {
			let data = JSON.parse(window.sessionStorage.getItem('inventoryCheckSelect'))
			this.dateValue = data.dateValue
			this.searchCode = data.searchCode
			this.searchDateType = data.searchDateType
			this.searchName = data.searchName
			this.maxInventory = data.maxInventory
			this.minInventory = data.minInventory
			if (this.searchDateType === 5) {
				this.timeDiy = this.dateValue[0] + ' - ' + this.dateValue[1]
			}
		}
	},
	methods: {
		// 库存输入
		orderInput () {
			this.minInventory = this.minInventory.replace(/[^\d-]/g, '')
			if (this.minInventory.lastIndexOf('-') > 0) {
				let numArr = this.minInventory.split('')
				numArr.splice(this.minInventory.lastIndexOf('-'), 1)
				this.minInventory = numArr.join('')
			}
		},
		orderInput2 () {
			this.maxInventory = this.maxInventory.replace(/[^\d-]/g, '')
			if (this.maxInventory.lastIndexOf('-') > 0) {
				let numArr = this.maxInventory.split('')
				numArr.splice(this.maxInventory.lastIndexOf('-'), 1)
				this.maxInventory = numArr.join('')
			}
		},
		// 选择日期
		changeTime (value) {
			this.searchDateType = value
			this.dateValue = []
			this.timeDiy = '自定义'
		},
		searchTime (value) {
			// window.sessionStorage.setItem('afterSearchTime', JSON.stringify(value))
			// console.log(value)
			if (value === null) {
				this.searchDateType = 0
				this.timeDiy = '自定义'
			} else {
				this.searchDateType = 5
				this.timeDiy = value[0] + ' - ' + value[1]
			}
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		checkTime () {
			if (this.dateValue === null || this.dateValue.length === 0) {
				this.$message.error('请选择正确时间范围！')
				return false
			}
			var begintime = this.dateValue[0]
			var endtime = this.dateValue[1]
			// 判断时间跨度是否大于12个月
			var arr1 = begintime.split('-')
			var arr2 = endtime.split('-')
			arr1[1] = parseInt(arr1[1])
			arr1[2] = parseInt(arr1[2])
			arr2[1] = parseInt(arr2[1])
			arr2[2] = parseInt(arr2[2])
			var flag = true
			if (arr2[0] - arr1[0] > 1) {
				flag = false
			} else if (arr2[0] - arr1[0] === 1) {
				if (arr1[1] < arr2[1]) { // 月相隔大于12个月
					flag = false
				} else if (arr1[1] === arr2[1]) { // 月相隔12个月，比较日
					if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
						flag = false
					}
				}
			}
			if (!flag) {
				this.$message.error('时间范围不得超过12个月！')
				return false
			}
			return true
		},
		search () {
			// this.dateValue = this.dateValue === null ? [] : this.dateValue
			// if (this.checkTime()) {
			if (this.minInventory && this.maxInventory && +this.maxInventory < +this.minInventory) {
				this.$message.error('请输入正确的库存区间')
				return false
			}
			this.$emit('handleSearch', { searchCode: this.searchCode, searchName: this.searchName, minInventory: this.minInventory, dateValue: this.dateValue, maxInventory: this.maxInventory, searchDateType: this.searchDateType })
			// }
		},
		// 导出
		exportExcel () {
			this.$emit('exportExcel')
		},
		clear () {
			// let value = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			// this.searchTime(value)
			this.clearAllInput()
			this.search()
		},
		clearAllInput () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			this.timeDiy = '自定义'
			this.searchCode = ''
			this.searchDateType = 0
			this.searchName = ''
			this.minInventory = ''
			this.maxInventory = ''
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	padding: 10px 0 0 0;
	width :100%;
	line-height :50px;
	min-width :600px;
	box-sizing: border-box
	text-align: left
	.inventory-input {
		width: 115px!important;
	}
	&.filters-box-row2 {
		padding-top: 0;
		.filters-container {
			display: flex
			flex-wrap: wrap
			.input-box {
				margin-right: 5px;
				display: flex;
				align-items: center;
				.time-box {
					display: flex;
					&>div {
						padding: 0 10px;
						text-align: center;
						height: 24px;
						line-height: 24px;
						border: 1px solid #ebeef5;
						border-radius: 4px;
						margin-right: 5px;
						cursor: pointer
						&.selected {
							color: var(--fx-primary-color);
							border: 1px solid var(--fx-primary-color);
						}
						&.time-diy {
							position: relative;
							padding-right: 5px;
							i {
								margin-left: 5px
							}
							.time-input {
								position: absolute;
								top: 0;
								bottom: 0;
								left: 0;
								right: 0;
								z-index: 9
								opacity: 0
								&.el-date-editor--datetimerange.el-input__inner {
									width: 100%
								}
							}
						}
					}
				}
			}
		}
	}
	&.filters-box-row3 {
		padding-top: 5px;
		height: 50px
	}
	.filters-container {
		margin-right: 5px
		.el-input {
			width: 180px
		}
		.time-input {
			// width: 310px;
			// margin-left: 10px;
		}
		.filter-input {
			width: 180px
		}
		.excel-icon {
			display inline-block
			height 20px
			width 20px
			background-repeat no-repeat
			background-position center
			vertical-align: sub;
			&.import-excel-icon {
				background-image: url('~images/icon/import-excel-icon.png')
			}
			&.export-excel-icon {
				background-image: url('~images/icon/export-excel-icon.png')
			}
		}
	}
}
</style>
<style lang="stylus">
	.export-btn {
		margin-left: 0
		span {
			display: flex;
			align-items: center
			div {
				width: 14px;
				height: 14px;
				margin-right: 5px;
				background-image: url('~images/icon/export-icon.png')
			}
		}
		&:hover {
			div {
				background-image: url('~images/icon/export-white-icon.png')
			}
		}
	}
	.input-tel input{
		-webkit-appearance: none;
		-webkit-box-sizing: content-box;
		font-family: inherit;
		font-size: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
</style>
